import { useEffect, useState } from "react";
import SessionService from "../../../../services/session/SessionService";
import ViewStateService from "../../../../services/view-state/ViewStateService";
import { LeftWrapper, MainStatusBarWrapper, NotifyButton, NotifyIcon, RightWrapper, UserProfileButton, ViewTitle } from "./MainStatusBar.styled";
import { Badge, Popover } from "antd";
import TaskList from "./component/task-list/TaskList";
import { AlertOutlined, BellOutlined, CloudDownloadOutlined, CloudSyncOutlined, FieldTimeOutlined, FileSyncOutlined, SyncOutlined, UserOutlined } from "@ant-design/icons";
import Account from "./component/account/Account";

interface MainStatusBarProps {

}

const MainStatusBar: React.FC<MainStatusBarProps> = (props)=> {
    // api
    let viewStateService = ViewStateService.getInstance();

    // current user profile
    let currentUserProfile = SessionService.getInstance().getCurrentUserProfile();

    // current title
    let [title, setTitle] = useState(viewStateService.getStatusBarTitle());
    let [openTaskList, setOpenTaskList] = useState(false);
    let [openAlarmEventList, setOpenAlarmEventList] = useState(false);
    let [unackedAlarmEventCount, setUnackedAlarmEventCount] = useState(0);

    // effect
    useEffect(()=> {
        // load
        let statusBarTitleChangeListener = (statusBarTitle)=> {
            setTitle(statusBarTitle);
        };
        viewStateService.addStatusBarTitleChnageListener(statusBarTitleChangeListener);

        let taskNotificationListener = ()=> {
            setOpenTaskList(true);
        };
        viewStateService.addNewTaskListener(taskNotificationListener);

        // unload
        return ()=> {
            viewStateService.removeStatusBarTitleChnageListener(statusBarTitleChangeListener);
            viewStateService.removeNewTaskListener(taskNotificationListener);
        }
    }, []);

    return (
        <MainStatusBarWrapper>
            <LeftWrapper>
                <ViewTitle>{title}</ViewTitle>
            </LeftWrapper>
            <RightWrapper>
                <Popover placement="bottom" content={<TaskList />} trigger="click" open={openTaskList} onOpenChange={(open)=> setOpenTaskList(open)}>
                    <NotifyButton onClick={()=> setOpenTaskList(true)}>
                        <FieldTimeOutlined />
                    </NotifyButton>
                </Popover>

                <Popover placement="bottom" title="" content={<Account />} trigger="click">
                    <NotifyButton>
                        <UserOutlined />
                    </NotifyButton>
                </Popover>
            </RightWrapper>
        </MainStatusBarWrapper>
    )
}

export default MainStatusBar;

